import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { BadgeContainer } from './styles';
const types = {
  success: {
    background: 'actionablePrimary',
    color: 'contentReverse'
  },
  warning: {
    background: 'semanticWarning',
    color: 'contentReverse'
  },
  error: {
    background: 'semanticError',
    color: 'contentReverse'
  },
  info: {
    background: 'actionableSecondary',
    color: 'contentReverse'
  }
};
const BadgeDefaultProps = {
  background: 'content',
  color: 'semanticInfo',
  size: 'normal',
  outline: false
};
const Badge = ({
  children,
  type,
  ...props
}) => {
  const p = {
    ...BadgeDefaultProps,
    ...props,
    ...(type ? types[type] : {})
  };

  // eslint-disable-next-line prefer-const
  let {
    background,
    color,
    border,
    size,
    outline,
    ...domProps
  } = p;
  color = outline ? background : color;
  background = outline ? 'transparent' : background;
  border = outline ? border || color : border || 'transparent';

  // If we set a border specifically, we style just
  // like outline but we don't re-assign the colors
  outline = outline || Boolean(props.border);
  return /*#__PURE__*/React.createElement(BadgeContainer, _extends({
    "data-outline": outline,
    "data-color": color,
    "data-background": background,
    "data-size": size,
    "data-border": border
  }, domProps), children);
};
Badge.propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  outline: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(types))
};
export default Badge;
//# sourceMappingURL=index.js.map